const contactSl = {
  breadcrumbs: { home: 'මුල් පිටුව', contact: 'අමතන්න' },
  hero: {
    title: 'අප හා සම්බන්ධ වන්න',
    subtitle: 'ඕනෑම ප්‍රශ්නයක, අදහස් හෝ සහාය සඳහා අපි මෙහි සිටිමු'
  },
  quick: {
    title: 'ඉක්මනින් උදව් ලබාගන්න',
    actions: {
      liveChat: { title: 'සජීව සංවාදය', desc: 'ක්ෂණික සහාය ලබාගන්න', cta: 'අරඹන්න' },
      helpCenter: { title: 'උදව් මධ්‍යස්ථානය', desc: 'වඩාත් සාමාන්‍ය ප්‍රශ්න වල පිළිතුරු', cta: 'ඇතුළු වන්න' },
      business: { title: 'ව්‍යාපාරික සම්බන්ධතා', desc: 'ගිවිසුම් සහ හවුල්කාරිත්ව', cta: 'අපව සම්බන්ධ කරන්න' }
    }
  },
  info: {
    title: 'සම්බන්ධතා තොරතුරු',
    service: { title: 'පාරිභෝගික සේවය', desc: 'පෙ.ව. 9 සිට ප.ව. 9 දක්වා' },
    email: { title: 'ඊමේල්', desc: 'පැය 24 ඇතුළත පිළිතුරු දෙමු' },
    address: {
      title: 'ලිපිනය',
      desc: 'සෙනසුරාදා සිට බ්‍රහස්පතින්දා, පෙ.ව. 9 - ප.ව. 6',
      primary: 'නිවස #12, කලාප මාර්ගය,',
      secondary: 'දුඛා ෆකීර් මෝර, ගුරුදාස්පුර, නාටෝර් - 6440'
    }
  },
  form: {
    title: 'පණිවිඩයක් යවන්න',
    desc: 'ඔබගේ විස්තර සමඟ පෝරමය පුරවන්න. පැය 24 ඇතුළත අපි සම්බන්ධ වෙමු.',
    name: 'නම',
    email: 'ඊමේල්',
    phone: 'දුරකථන',
    subject: 'විෂය',
    message: 'පණිවුඩය',
    messagePh: 'ඔබගේ ප්‍රශ්නය/අදහස් විස්තරව ලෙස ලියන්න...',
    submit: 'යවන්න',
    success: 'ඔබගේ පණිවිඩය සාර්ථකව යවනු ලැබීය. ඉක්මනින් අපි සම්බන්ධ වෙමු.'
  },
  hours: {
    title: ' කාර්යාල වේලාවන්',
    weekdays: 'සෙනසුරාදා - බ්‍රහස්පතින්දා',
    friday: 'සිකුරාදා',
    note: 'ජනප්‍රිය නිවාඩු නිසා සිකුරාදා මෙහෙයුම් සීමිතය'
  },
  social: { title: 'සමාජ මාධ්‍ය' },
  faq: {
    title: 'නිතර අසන ප්‍රශ්න',
    subtitle: 'ඔබගේ පිළිතුර අපගේ උදව් කොටසේ තිබිය හැක',
    cta: 'උදව් මධ්‍යස්ථානයට යන්න'
  }
};

export default contactSl;


